const benefits = [
  {
    icon: "ri-flashlight-line",
    title: "Rapid Dispatch",
    description:
      "24/7/365 dispatch operations mean an operator is always ready to respond. No answering services, no delays — real people coordinating real response.",
  },
  {
    icon: "ri-user-star-line",
    title: "Experienced Operators",
    description:
      "Over three decades of field experience across towing, recovery, and heavy transport. Our team handles complex situations with precision and professionalism.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Secure Handling",
    description:
      "Impound facilities protected by electric gates and 24-hour surveillance. Every vehicle is handled with care and documented throughout the process.",
  },
  {
    icon: "ri-government-line",
    title: "Institutional Trust",
    description:
      "Contracted by the City of Riverside and City of Moreno Valley. Trusted by state and local law enforcement agencies across Southern California.",
  },
  {
    icon: "ri-map-2-line",
    title: "Local Coverage Authority",
    description:
      "Multiple facilities across the Inland Empire — Riverside and Moreno Valley — providing comprehensive coverage throughout the region.",
  },
  {
    icon: "ri-heart-line",
    title: "Family-Owned Since 1991",
    description:
      "Founded by Jerry Kohutek in 1991, Exclusive Recovery Inc has built its reputation on accountability, consistency, and community presence for over 33 years.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="bg-[#0a0a0c] py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left statement */}
          <div className="lg:w-2/5 lg:sticky lg:top-28">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-[#D4AF37]"></div>
              <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">Our Advantage</span>
            </div>
            <h2
              className="text-white font-black text-4xl md:text-5xl leading-tight mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Why Riverside Trusts Exclusive Recovery
            </h2>
            <div className="w-16 h-1 bg-[#D4AF37] mb-6"></div>
            <p className="text-[#888] text-base leading-relaxed mb-8">
              More than three decades of reliable service, institutional contracts, and a family-owned commitment to doing the job right — every time.
            </p>
            <a
              href="tel:9516822003"
              className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-bold px-6 py-3 rounded-sm tracking-wider uppercase text-sm hover:bg-[#c49f27] transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </div>
              (951) 682-2003
            </a>
          </div>

          {/* Right grid */}
          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {benefits.map((b, i) => (
              <div
                key={i}
                className="bg-[#111113] border border-[#2a2a2c] rounded-lg p-6 hover:border-[#D4AF37]/30 transition-colors duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center shrink-0 bg-[#D4AF37]/10 rounded-sm">
                    <i className={`${b.icon} text-[#D4AF37] text-xl`}></i>
                  </div>
                  <div>
                    <h3
                      className="text-white font-bold text-base mb-2"
                      style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                      {b.title}
                    </h3>
                    <p className="text-[#888] text-sm leading-relaxed">{b.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
